<template>
    <div v-if="value">
        <v-row>
            <v-col cols="12" md="8">
                <v-row v-if="!simple">
                    <v-col>
                        <eod-text-field :value="value.name" @input="val => updateProperty('name', val)" :rules="nameRules"
                            label="Naam*" required :readonly="readonly"></eod-text-field>
                    </v-col>
                    <v-col>
                        <eod-text-field :value="value.description" @input="val => updateProperty('description', val)"
                            label="Omschrijving" :readonly="readonly"></eod-text-field>
                    </v-col>
                </v-row>
                <eod-autocomplete v-if="!simple" class="my-4" label="Categorie*" :rules="categoryRules" :value="value.category"
                    @input="val => updateProperty('category', val)" :readonly="readonly"
                    :items="[{ value: 'home', text: 'Thuisadres' }, { value: 'warehouse', text: 'Depot' }]">
                </eod-autocomplete>

                <v-row>
                    <v-col cols="12">
                        <eod-text-field :rules="[val => rules.required(value, val, 'Straat + nummer')]"
                            :readonly="readonly" :value="value.streetAddress"
                            @input="val => updateProperty('streetAddress', val)"
                            :label="'Straat + nummer'+(rules.required(value, value.streetAddress, null) != true?'*':'')"></eod-text-field>
                    </v-col>
                    <v-col cols="4">
                        <eod-text-field :readonly="readonly" :value="value.postalCode"
                            @input="val => updateProperty('postalCode', val)" label="Postcode"></eod-text-field>
                    </v-col>
                    <v-col cols="8">
                        <eod-text-field :rules="[val => rules.required(value, val, 'Stad/Gemeente')]"
                            :readonly="readonly" :value="value.locality"
                            @input="val => updateProperty('locality', val)"
                            :label="'Stad/Gemeente'+(rules.required(value, value.locality, null) != true?'*':'')"></eod-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-if="!simple">
                        <eod-text-field :readonly="readonly" :value="value.region"
                            @input="val => updateProperty('region', val)" label="Regio"></eod-text-field>
                    </v-col>
                    <v-col>
                        <eod-text-field :rules="[val => rules.required(value, val, 'Land')]" :readonly="readonly" outlined
                            hide-details :value="value.country" @input="val => updateProperty('country', val)"
                            :label="'Land'+(rules.required(value, value.country, null) != true?'*':'')"></eod-text-field>
                    </v-col>
                </v-row>
                
                <eod-textarea v-if="!simple" class="mt-4" :readonly="readonly" :value="value.notes"
                    @input="val => updateProperty('notes', val)" label="Opmerkingen"></eod-textarea>
            </v-col>
            <v-col>
                <eod-location-form :value="value" @update="val => updateAddress(val)"></eod-location-form>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import eodLocationForm from './eod-location-form.vue';
export default {
    name: 'eod-depot-detail',
    components:{
        eodLocationForm
    },
    props: {
        value: Object,
        readonly: {
            type: Boolean,
            default: false
        },
        simple: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            nameRules: [
                v => this.readonly || !!v || 'Adresnaam is verplicht',
            ],
            categoryRules: [
                v => this.readonly || !!v || 'Categorie is verplicht',
            ],
            rules: {
                required: (item, value, fieldName) => {
                    // Een readonly weergave (bv. het geselecteerde depot in het
                    // medewerkersformulier) mag de validatie niet blokkeren: de velden
                    // zijn dan niet invulbaar. Verplichting geldt enkel in bewerkmodus.
                    if(this.readonly){
                        return true;
                    }
                    if(((item.streetAddress && item.streetAddress != '') || (item.locality && item.locality != '')) && !value){
                        return (fieldName ? fieldName : 'Veld') + ' is verplicht.';
                    }

                    return true;
                },
            },
        }
    },
    methods: {
        updateAddress(address){
            const val = this.value;

            if(address.road){
                val.streetAddress = address.road;

                if(address.house_number){
                    val.streetAddress += ' ' + address.house_number;
                }
            }
            
            if(address.country){
                val.country = address.country;
            }

            if(address.town || address.village){
                val.locality = address.town?address.town:address.village;
            }
            
            if(address.postcode){
                val.postalCode = address.postcode;
            }

            if(address.state){
                val.region = address.state;
            }

            this.$emit('input', val);
            this.$forceUpdate();
        },
        updateProperty(property, value) {
            let val = this.value;
            val[property] = value;
            this.$emit('input', val);
            this.$forceUpdate();
        }
    }
}
</script>